/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize TermsAndConditions View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './termsAndConditionsView';

export const mapStateToPropsTermsAndConditionsView = mapStateToProps;
export const mapDispatchToPropsTermsAndConditionsView = mapDispatchToProps;

export default connect(
  mapStateToPropsTermsAndConditionsView,
  mapDispatchToPropsTermsAndConditionsView
)(View);
